angular.module('moebiusProadapt').controller('ctrlUtilisateursAddUser',
    [
        '$rootScope', '$scope', '$http', '$location', '$uibModal', 'growl', 'promiseTracker', 'user', 'mbsUser', function($rootScope, $scope, $http, $location, $uibModal, growl, promiseTracker, user, mbsUser) {

        $scope.tracker = promiseTracker('tracker');
        $scope.user = user;


        var roles = $rootScope.constants.roles.NAMES_TO_VALUES;

        // If user is not admin, he CANT create or modify some role
        var excludedRoles = $rootScope.userHasRight($rootScope.rights.ADMIN) ? [] : [
                roles.admin.toString(),
                roles.oauth.toString(),
            ];

        $scope.roleList = [];

        Object.keys($rootScope.constants.roles.VALUES_TO_NAMES).map(r => {
            if(excludedRoles.includes(r)){
                return;
            }

            $scope.roleList.push({
                key:r,
                value:$rootScope.constants.roles.VALUES_TO_NAMES[r],
                label:$rootScope.constants.roles.VALUES_TO_DISPLAY[r],
            })
        });

        // Those rights means that user doesn't need a centre_id
        $scope.isUserNeedsCenterId = function(user){
            if(!user.role){
                return true;
            }
            user.rights = $rootScope.constants.rights[user.role];
            return !$rootScope.userHasRight([$rootScope.rights.ADMIN], user);
        }

        //check if form is correctly filled then activate Form validation btn
        $scope.isEnabledForm = function(user) {
            if( !user.name || !user.email || !user.role ||
               (!user.centre_id && $scope.isUserNeedsCenterId(user))){
                return false;
            }
            return true;
        }

        //at form validation, send its data to back to create a new user
        $scope.editUser = function(user) {

            user.role = parseInt(user.role);

            if (!$scope.isUserNeedsCenterId(user)){
                user.centre_id = null;
            }

            return $http.post('register', user)
                        .then(function(r) {
                            $scope.$close(r.data);
                        }, function (e) {
                            var errorMsg = '';
                            if (e.data ) {
                                if ( e.data.message) {
                                    errorMsg += e.data.message;
                                }
                                if ( e.data.errors) {
                                    _.each(e.data.errors, function(error, k) {
                                        errorMsg += '<br>' +k  + ' : ' + error[0];
                                    })
                                }
                            }
                            growl.error(errorMsg, { ttl: 5000 });
                            console.log(e);
                    }
                );
        }

        //at form validation, send its data to back to create a new user
        $scope.desactivateUser = function(user) {

            return $http.post('desactivate', user)
                        .then(function(r) {
                            if(r.data.deleted_at !== null) {
                                $scope.users.splice(_.findIndex($scope.users, { id: user.id }), 1);
                            }
                            $scope.$close(r.data);
                        });
        }

    }
    ]
);



// WEBPACK FOOTER //
// ./resources/assets/js/controllers/utilisateurs/utilisateursAddUser.js